<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['select', 'unselect'])
</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>Номер</th>
          <th>Название</th>
          <th>Подразделение</th>
          <th>Наличие СОУТ</th>
          <th>Количество факторов/ опасностей/ работ</th>
          <th class="text-center mw-100">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Uuid"
        >
          <td>{{ record.Number || '—' }}</td>
          <td>
            <RouterLink
              v-if="record.Uuid"
              :to="{ name: 'workplace', params: { uuid: record.Uuid } }"
              target="_blank"
            >
              {{ record.Name || '—' }}
            </RouterLink>
            <template v-else>
              {{ record.Name || '—' }}
            </template>
          </td>
          <td>{{ record.Department || '—' }}</td>
          <td>
            <VIcon
              v-if="record.ScoreBool"
              icon="mdi-check"
            />
            <template v-else>
              —
            </template>
          </td>
          <td>{{ record.FhwCounters || '—' }}</td>
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Uuid)"
              @set="emit('select', record)"
              @delete="emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
